"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24077],{

/***/ 290184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CashColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CashColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.435 5C2.195 5 2 5.195 2 5.436V17.609C2 17.849 2.195 18.044 2.435 18.044H21.565C21.806 18.044 22 17.849 22 17.609V5.436C22 5.195 21.806 5 21.565 5H2.435Z",
          fill: "#1CC54F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.9142 6.30505C5.9142 7.74505 4.7452 8.91305 3.3042 8.91305V14.1301C4.7452 14.1301 5.9142 15.2991 5.9142 16.7401H18.0882C18.0882 15.2991 19.2552 14.1301 20.6962 14.1301V8.91305C19.2552 8.91305 18.0882 7.74505 18.0882 6.30505H5.9142Z",
          fill: "#B9F5B4"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.95703 11.522C8.95703 13.203 10.319 14.566 12 14.566C13.681 14.566 15.044 13.203 15.044 11.522C15.044 9.841 13.681 8.479 12 8.479C10.319 8.479 8.95703 9.841 8.95703 11.522Z",
          fill: "#1CC54F"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 971219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ GiftColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const GiftColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 26 26", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { filter: "url(#filter0_d)" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.6364 6.9847L8.7767 5.151C8.25219 4.81467 7.55366 5.06457 7.35706 5.65888L6.79962 7.34394C6.57498 8.02303 7.1381 8.70292 7.84136 8.60169L11.0885 8.13427C11.0798 8.20942 11.0754 8.28587 11.0754 8.36336C11.0754 9.44791 11.9479 10.3271 13.0242 10.3271C14.1006 10.3271 14.9731 9.44791 14.9731 8.36336C14.9731 8.2883 14.9689 8.21422 14.9608 8.14135L18.1588 8.60169C18.862 8.70292 19.4252 8.02303 19.2005 7.34394L18.6431 5.65888C18.4465 5.06457 17.7479 4.81467 17.2234 5.151L14.3933 6.96575C14.0413 6.6157 13.5578 6.39962 13.0242 6.39962C12.4811 6.39962 11.9898 6.62351 11.6364 6.9847Z",
              fill: "url(#paint0_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M6.04004 11.2901C6.04004 10.7583 6.46789 10.3271 6.99567 10.3271H19.0044C19.5322 10.3271 19.96 10.7583 19.96 11.2901V19.8687C19.96 20.4005 19.5322 20.8316 19.0044 20.8316H6.99567C6.46789 20.8316 6.04004 20.4005 6.04004 19.8687V11.2901Z",
              fill: "url(#paint1_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5 8.73245C5 8.20065 5.42785 7.76953 5.95563 7.76953H20.0444C20.5722 7.76953 21 8.20065 21 8.73245V11.3294C21 11.8613 20.5722 12.2924 20.0444 12.2924H5.95563C5.42785 12.2924 5 11.8613 5 11.3294V8.73245Z",
              fill: "url(#paint2_radial)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10.71 7.76953H15.2899V12.2924H10.71V7.76953Z",
              fill: "#FED546"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.0269 12.2925H14.9729V20.8316H11.0269V12.2925Z",
              fill: "url(#paint3_linear)"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "filter",
            attr: {
              id: "filter0_d",
              x: "0",
              y: "0",
              width: "26",
              height: "25.8316",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB"
            },
            child: [
              {
                tag: "feFlood",
                attr: { floodOpacity: "0", result: "BackgroundImageFix" }
              },
              {
                tag: "feColorMatrix",
                attr: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }
              },
              { tag: "feOffset", attr: {} },
              { tag: "feGaussianBlur", attr: { stdDeviation: "2.5" } },
              {
                tag: "feColorMatrix",
                attr: {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 0.528167 0 0 0 0 0.379167 0 0 0 0.29 0"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow",
                  result: "shape"
                }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "13.0001",
              y1: "5",
              x2: "13.0001",
              y2: "8.30689",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FFB81E" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FED546" } }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint1_linear",
              x1: "13",
              y1: "10.3271",
              x2: "13",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          },
          {
            tag: "radialGradient",
            attr: {
              id: "paint2_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "translate(7.61979 9.61593) rotate(61.073) scale(9.30482 8.68326)"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF5B6F" } },
              {
                tag: "stop",
                attr: { offset: "0.46875", stopColor: "#FF444F" }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint3_linear",
              x1: "12.9999",
              y1: "12.2925",
              x2: "12.9999",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              {
                tag: "stop",
                attr: { stopColor: "#FFB81E", stopOpacity: "0.66" }
              },
              {
                tag: "stop",
                attr: { offset: "0.608277", stopColor: "#FFB81E" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 526397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VoucherColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const VoucherColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.563 20C14.785 19.1374 15.5681 18.5 16.5 18.5C17.4319 18.5 18.215 19.1374 18.437 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H18.437C18.215 4.86261 17.4319 5.5 16.5 5.5C15.5681 5.5 14.785 4.86261 14.563 4L4 4C2.89543 4 2 4.89543 2 6L2 18C2 19.1046 2.89543 20 4 20H14.563ZM10.3057 13.6328C10.3057 13.3757 10.2422 13.1738 10.1152 13.0273C9.98828 12.8809 9.7653 12.7425 9.44629 12.6123C9.12728 12.4821 8.83268 12.3503 8.5625 12.2168C8.29232 12.0833 8.05957 11.9287 7.86426 11.7529C7.66895 11.5771 7.51921 11.3737 7.41504 11.1426C7.31087 10.9115 7.25879 10.6315 7.25879 10.3027C7.25879 9.7526 7.44434 9.30013 7.81543 8.94531C8.18652 8.58724 8.68131 8.37891 9.2998 8.32031V7.29004H10.0762V8.33984C10.6719 8.42773 11.139 8.6735 11.4775 9.07715C11.8193 9.47754 11.9902 9.98698 11.9902 10.6055H10.3398C10.3398 10.2669 10.2747 10.0065 10.1445 9.82422C10.0143 9.64193 9.82878 9.55078 9.58789 9.55078C9.37305 9.55078 9.2054 9.61914 9.08496 9.75586C8.96777 9.88932 8.90918 10.0749 8.90918 10.3125C8.90918 10.5534 8.97754 10.7454 9.11426 10.8887C9.25098 11.0286 9.4707 11.1637 9.77344 11.2939C10.0762 11.4209 10.361 11.5544 10.6279 11.6943C10.8981 11.8311 11.1309 11.9873 11.3262 12.1631C11.5215 12.3389 11.6745 12.5439 11.7852 12.7783C11.8958 13.0127 11.9512 13.2943 11.9512 13.623C11.9512 14.1797 11.7738 14.6338 11.4189 14.9854C11.0674 15.3369 10.5872 15.542 9.97852 15.6006V16.582H9.20215V15.5957C8.49251 15.5208 7.94727 15.2783 7.56641 14.8682C7.1888 14.4548 7 13.9111 7 13.2373H8.64551C8.64551 13.6084 8.72689 13.8916 8.88965 14.0869C9.05566 14.279 9.29004 14.375 9.59277 14.375C9.81413 14.375 9.98828 14.3099 10.1152 14.1797C10.2422 14.0462 10.3057 13.8639 10.3057 13.6328ZM17.2002 16.4C17.2002 16.7314 16.9316 17 16.6002 17C16.2688 17 16.0002 16.7314 16.0002 16.4V15.52C16.0002 15.1886 16.2688 14.92 16.6002 14.92C16.9316 14.92 17.2002 15.1886 17.2002 15.52V16.4ZM17.2002 12.88C17.2002 13.2114 16.9316 13.48 16.6002 13.48C16.2688 13.48 16.0002 13.2114 16.0002 12.88L16.0002 11.12C16.0002 10.7886 16.2688 10.52 16.6002 10.52C16.9316 10.52 17.2002 10.7886 17.2002 11.12V12.88ZM17.2002 8.48C17.2002 8.81137 16.9316 9.08 16.6002 9.08C16.2688 9.08 16.0002 8.81137 16.0002 8.48V7.6C16.0002 7.26863 16.2688 7 16.6002 7C16.9316 7 17.2002 7.26863 17.2002 7.6V8.48Z",
          fill: "url(#paint0_linear)"
        }
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "12",
              y1: "20",
              x2: "12",
              y2: "4",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 78549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ VoucherFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const VoucherFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.563 20C14.785 19.1374 15.5681 18.5 16.5 18.5C17.4319 18.5 18.215 19.1374 18.437 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H18.437C18.215 4.86261 17.4319 5.5 16.5 5.5C15.5681 5.5 14.785 4.86261 14.563 4L4 4C2.89543 4 2 4.89543 2 6L2 18C2 19.1046 2.89543 20 4 20H14.563ZM10.3057 13.6328C10.3057 13.3757 10.2422 13.1738 10.1152 13.0273C9.98828 12.8809 9.7653 12.7425 9.44629 12.6123C9.12728 12.4821 8.83268 12.3503 8.5625 12.2168C8.29232 12.0833 8.05957 11.9287 7.86426 11.7529C7.66895 11.5771 7.51921 11.3737 7.41504 11.1426C7.31087 10.9115 7.25879 10.6315 7.25879 10.3027C7.25879 9.7526 7.44434 9.30013 7.81543 8.94531C8.18652 8.58724 8.68131 8.37891 9.2998 8.32031V7.29004H10.0762V8.33984C10.6719 8.42773 11.139 8.6735 11.4775 9.07715C11.8193 9.47754 11.9902 9.98698 11.9902 10.6055H10.3398C10.3398 10.2669 10.2747 10.0065 10.1445 9.82422C10.0143 9.64193 9.82878 9.55078 9.58789 9.55078C9.37305 9.55078 9.2054 9.61914 9.08496 9.75586C8.96777 9.88932 8.90918 10.0749 8.90918 10.3125C8.90918 10.5534 8.97754 10.7454 9.11426 10.8887C9.25098 11.0286 9.4707 11.1637 9.77344 11.2939C10.0762 11.4209 10.361 11.5544 10.6279 11.6943C10.8981 11.8311 11.1309 11.9873 11.3262 12.1631C11.5215 12.3389 11.6745 12.5439 11.7852 12.7783C11.8958 13.0127 11.9512 13.2943 11.9512 13.623C11.9512 14.1797 11.7738 14.6338 11.4189 14.9854C11.0674 15.3369 10.5872 15.542 9.97852 15.6006V16.582H9.20215V15.5957C8.49251 15.5208 7.94727 15.2783 7.56641 14.8682C7.1888 14.4548 7 13.9111 7 13.2373H8.64551C8.64551 13.6084 8.72689 13.8916 8.88965 14.0869C9.05566 14.279 9.29004 14.375 9.59277 14.375C9.81413 14.375 9.98828 14.3099 10.1152 14.1797C10.2422 14.0462 10.3057 13.8639 10.3057 13.6328ZM17.2002 16.4C17.2002 16.7314 16.9316 17 16.6002 17C16.2688 17 16.0002 16.7314 16.0002 16.4V15.52C16.0002 15.1886 16.2688 14.92 16.6002 14.92C16.9316 14.92 17.2002 15.1886 17.2002 15.52V16.4ZM17.2002 12.88C17.2002 13.2114 16.9316 13.48 16.6002 13.48C16.2688 13.48 16.0002 13.2114 16.0002 12.88L16.0002 11.12C16.0002 10.7886 16.2688 10.52 16.6002 10.52C16.9316 10.52 17.2002 10.7886 17.2002 11.12V12.88ZM17.2002 8.48C17.2002 8.81137 16.9316 9.08 16.6002 9.08C16.2688 9.08 16.0002 8.81137 16.0002 8.48V7.6C16.0002 7.26863 16.2688 7 16.6002 7C16.9316 7 17.2002 7.26863 17.2002 7.6V8.48Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 333577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ProductVariantsMobile; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _VariantItem_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(390368);




const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div``;
const VariantWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  flex-wrap: wrap;
  overflow-y: hidden;
  overflow-x: auto;
`;
const SelectedVariant = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  color: #82869e;
  margin-bottom: 4px;
  text-transform: uppercase;
`;
const ProductVariantsMobile = ({
  configuration,
  onSelectVariant,
  index,
  className
}) => {
  const selectedOption = configuration.options.find((variant) => {
    return variant.selected;
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectedVariant, null, configuration.name, selectedOption ? `: ${selectedOption.value}` : ``), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VariantWrapper, null, configuration.options.map((variant) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_VariantItem_es_js__WEBPACK_IMPORTED_MODULE_2__/* .VariantItem */ .D, {
    key: variant.optionId,
    option: variant,
    onSelectVariant,
    index
  }))));
};




/***/ }),

/***/ 390368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ VariantItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);



const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ isThumbnail, theme, isVisible, isActive }) => `
    width: ${isThumbnail ? "32px" : "fit-content"};
    height: ${isThumbnail ? "32px" : "fit-content"};
    border: 1px ${isActive ? theme.brand.primary : "#e0e0e0"} solid;
    position: relative;
    border-radius: 4px;

    margin: 0 8px 12px 0;
    padding: ${isThumbnail ? "4px" : "8px 16px"};
    color: 'black';
    background-color: ${isVisible || isActive ? "#fff" : "#e0e0e0"};
    text-transform: capitalize;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: ${isVisible || isActive ? "pointer" : "not-allowed"};
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
`);
const Value = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span``;
const VariantItem = ({ option, index, onSelectVariant }) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    isActive: option.selected,
    isVisible: option.visible,
    onClick: () => onSelectVariant(option, index),
    isThumbnail: !!option.thumbnailUrl
  }, option.thumbnailUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w, {
    src: option.thumbnailUrl
  })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Value, null, option.value));
};




/***/ }),

/***/ 836282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(280392);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54230);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(284587);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(353632);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







const Quantity = (props)=>{
    const { numberDisplayFormat  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Quantity */ .h, _objectSpread({}, (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getEnv */ .dU)("EPIC_ECOM_489") === "enabled" ? {
        decimalSeparator: (numberDisplayFormat === null || numberDisplayFormat === void 0 ? void 0 : numberDisplayFormat.decimalSeparator) || constants_index__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator,
        formatter: (value)=>(0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .numberFormatter */ .V2)(value, numberDisplayFormat || constants_index__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_NUMBER_DISPLAY_FORMAT */ .n6),
        parser: (value)=>(0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .numberParser */ .kX)(value, numberDisplayFormat || constants_index__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_NUMBER_DISPLAY_FORMAT */ .n6)
    } : {}, props));
};


/***/ }),

/***/ 373137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mo": function() { return /* binding */ PromotionOption; }
/* harmony export */ });
/* unused harmony exports renderIcon, getPromoTitle, getConditionText */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(356026);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78549);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(526439);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(855271);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





const getTextDiscount = (moneyPromotion, blockSizeDecimal, productUnitName)=>{
    if (moneyPromotion.discountType === "percent") {
        // Giảm %
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Giảm"),
                " ",
                moneyPromotion.percent,
                "%",
                !!moneyPromotion.maxDiscount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        " ",
                        (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tối đa"),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F, {
                            value: moneyPromotion.maxDiscount || 0
                        })
                    ]
                })
            ]
        });
    }
    const blockSizeText = blockSizeDecimal > 1 ? blockSizeDecimal : "";
    const productUnitNameText = productUnitName || (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("sản phẩm");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Giảm"),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F, {
                value: moneyPromotion.money || 0
            }),
            " / ".concat(blockSizeText),
            " ".concat(productUnitNameText)
        ]
    });
};
const renderIcon = (promo)=>{
    var ref, ref1;
    const { benefit ={}  } = promo || {};
    const isGiftOrMoneyBenefit = ((ref = benefit.money) === null || ref === void 0 ? void 0 : ref.length) || ((ref1 = benefit.items) === null || ref1 === void 0 ? void 0 : ref1.length);
    return isGiftOrMoneyBenefit ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .GiftFilled */ .p, {
        color: "primary500",
        size: 32
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .VoucherFilled */ .$, {
        color: "primary500",
        size: 32
    });
};
const getPromoTitle = (promo, blockSizeDecimal, productUnitName)=>{
    var ref, ref1, ref2;
    const { benefit ={}  } = promo || {};
    const titles = [];
    // Example: Giảm 10.000đ / Kg, tặng 2x quà, 1x voucher
    // Money
    if ((ref = benefit.money) === null || ref === void 0 ? void 0 : ref.length) {
        titles.push(getTextDiscount(benefit.money[0], blockSizeDecimal, productUnitName));
    }
    let prefixForGiftVoucher = "".concat(titles.length ? (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Tặng").toLowerCase() : (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Tặng"), " ");
    // Gift
    if ((ref1 = benefit.items) === null || ref1 === void 0 ? void 0 : ref1.length) {
        let itemTitle = prefixForGiftVoucher;
        prefixForGiftVoucher = "";
        benefit.items.forEach((param)=>{
            let { quantity , name  } = param;
            itemTitle += "".concat(quantity, "x ").concat(name, ", ");
        });
        titles.push(itemTitle.substr(0, itemTitle.length - 2));
    }
    // Voucher
    if ((ref2 = benefit.voucher) === null || ref2 === void 0 ? void 0 : ref2.name) {
        const { voucher  } = benefit;
        titles.push("".concat(prefixForGiftVoucher).concat(voucher.quantity, "x ").concat(voucher.name));
    }
    const totalBenefits = titles.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: titles.map((title, index)=>{
            const isLastTitle = index === totalBenefits - 1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    title,
                    !isLastTitle && ", "
                ]
            }, index);
        })
    });
};
const getConditionText = (minQuantity, productUnitName)=>{
    if (!minQuantity) return null;
    return (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Khi mua từ {{quantity}} {{productUnitName}} trở l\xean", {
        quantity: minQuantity,
        productUnitName: productUnitName || (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("sản phẩm")
    });
};
const PromotionOption = (_param)=>{
    var { promotion , className , active =false , onClick , productUnitName =""  } = _param, props = _objectWithoutProperties(_param, [
        "promotion",
        "className",
        "active",
        "onClick",
        "productUnitName"
    ]);
    const renderPromotionContent = ()=>{
        var ref, ref1;
        const blockSizeDecimal = (promotion === null || promotion === void 0 ? void 0 : (ref = promotion.condition) === null || ref === void 0 ? void 0 : ref.blockSizeDecimal) || 0;
        const minQuantityDecimal = (promotion === null || promotion === void 0 ? void 0 : (ref1 = promotion.condition) === null || ref1 === void 0 ? void 0 : ref1.minQuantityDecimal) || 0;
        const conditionText = getConditionText(minQuantityDecimal, productUnitName);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PromotionContent, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                            active: active,
                            children: getPromoTitle(promotion, blockSizeDecimal, productUnitName)
                        }),
                        conditionText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionText, {
                            children: conditionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ExpiredAndApplied, {
                    children: [
                        promotion.endedAt ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpiredAt, {
                            children: "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("HSD"), ": ").concat(new Date(promotion.endedAt).toLocaleDateString("vi"))
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CTA, {
                            children: active ? (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Bỏ chọn") : (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("\xc1p dụng")
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, _objectSpreadProps(_objectSpread({
        className: className,
        isActive: active,
        onClick: ()=>onClick(promotion.id)
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                children: renderIcon(promotion)
            }),
            renderPromotionContent()
        ]
    }));
};
const Item = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div((param)=>{
    let { isActive , theme  } = param;
    return "\n    width: 100%;\n    display: flex;\n    margin-top: 10px;\n    padding: 12px;\n    border-radius: 8px;\n  \n    background-color: ".concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary50 : "#ffffff", ";\n    border: 1px solid ").concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "#E4E5F0", ";\n    cursor: pointer;\n  ");
});
const IconWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div((param)=>{
    let { theme  } = param;
    return "\n  height: 64px;\n  width: 64px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n  border-radius: 4px;\n  background-color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary100, ";\n");
});
const PromotionContent = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject());
const maxLineCss = (maxLines)=>"\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ".concat(maxLines, ";\n  ");
const Label = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div((param)=>{
    let { active , theme  } = param;
    return "\n      font-size: 13px;\n      font-weight: 500;\n      line-height: 20px;\n      ".concat(maxLineCss(2), "\n      color: ").concat(active ? "#1B1D29" : theme === null || theme === void 0 ? void 0 : theme.colors.text, ";\n    ");
});
const ConditionText = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div((param)=>{
    let { theme  } = param;
    return "\n    margin-top: 4px;\n    font-size: 12px;\n    line-height: 16px;\n    color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.neutral, ";\n    ").concat(maxLineCss(2), "\n  ");
});
const ExpiredAndApplied = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject1());
const ExpiredAt = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div((param)=>{
    let { theme  } = param;
    return "\n      font-size: 12px;\n      line-height: 16px;\n      color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.neutral, ";\n    ");
});
const CTA = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div((param)=>{
    let { theme  } = param;
    return "\n      font-size: 13px;\n      line-height: 20px;\n      color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.link500, ";\n    ");
});


/***/ }),

/***/ 627735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useCartCombo; }
/* harmony export */ });
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(534090);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const useCartCombo = (mainSku)=>{
    const { onAddMultipleItems , onAddComboItems  } = (0,contexts__WEBPACK_IMPORTED_MODULE_0__/* .useCartV2 */ .T6)();
    const onAddComboToCart = !mainSku ? null : async function(type, payload) {
        let override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (type === "autogen") {
            const body = payload.comboLineItems.map((item)=>_objectSpreadProps(_objectSpread({}, item), {
                    promotionId: item.selectPromotionId
                }));
            await onAddMultipleItems(body);
        } else {
            const mainPayload = {
                override,
                groups: [
                    {
                        quantity: 1,
                        promotionId: payload.promotionId,
                        products: payload.comboLineItems.map((el, index)=>({
                                sku: el.sku,
                                quantity: el.quantity,
                                isPrimary: index === 0
                            }))
                    }, 
                ]
            };
            await onAddComboItems(mainPayload, false);
        }
    };
    return {
        onAddComboToCart
    };
};


/***/ }),

/***/ 554068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hz": function() { return /* binding */ useDynamicSelectedProduct; },
/* harmony export */   "JC": function() { return /* binding */ useDetailCombo; },
/* harmony export */   "zX": function() { return /* binding */ useAutogenSelectedProduct; }
/* harmony export */ });
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(643015);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(681889);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);
/* harmony import */ var _useDiscovery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88837);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(927250);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const useDetailCombo = (type, payload)=>{
    const { 0: products , 1: setProducts  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { 0: payloadCombo , 1: setPayloadCombo  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(payload);
    const { 0: comboPromotion , 1: setComboPromotion  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const { 0: supplierRetailPrice , 1: setSupplierRetailPrice  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const { 0: latestPrice , 1: setLatestPrice  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const skus = ((payloadCombo === null || payloadCombo === void 0 ? void 0 : payloadCombo.comboLineItems) || []).map((el)=>el.sku);
    const { location  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const fetcherListProduct = ()=>{
        return Promise.all(skus.map((sku)=>discoveryService.getProduct({
                sku,
                location
            })));
    };
    const { data: dataAutogenCombo , error: errorAutogen  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(type === "autogen" && (skus === null || skus === void 0 ? void 0 : skus.length) ? [
        "".concat(discoveryService.getBaseUrl, "/list-product"),
        JSON.stringify(skus)
    ] : null, fetcherListProduct, {
        revalidateOnFocus: false
    });
    const { result: { combo: dataDynamicCombo  } , isLoading: isLoadingDynamicCombo ,  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_4__/* .useRecommendationComboDetail */ .lR)(payloadCombo, type === "dynamic");
    const updatePrice = (newProducts)=>{
        setSupplierRetailPrice(newProducts.reduce((acc, curr)=>{
            return acc + (curr.quantity || 0) * curr.supplierRetailPrice;
        }, 0));
        setLatestPrice(newProducts.reduce((acc, curr)=>{
            return acc + (curr.quantity || 0) * curr.latestPrice;
        }, 0));
    };
    const onChangeQuantity = (sku, value)=>{
        if (type === "autogen") {
            const newProducts = products.map((el)=>{
                if (el.sku === sku) {
                    return _objectSpreadProps(_objectSpread({}, el), {
                        quantity: value
                    });
                }
                return el;
            });
            setProducts(newProducts);
            updatePrice(newProducts);
        }
    };
    const onChangeAutogenProduct = (index, newProduct)=>{
        const newProducts = products.map((el, idx)=>{
            if (index === idx) return newProduct;
            return el;
        });
        setProducts(newProducts);
        setPayloadCombo({
            comboLineItems: newProducts.map((prod)=>({
                    sku: prod.sku,
                    sellerSku: prod.sellerSku,
                    quantity: prod.quantity,
                    selectPromotionId: prod.selectionPromotionId
                }))
        });
        updatePrice(newProducts);
    };
    const onChangeDynamicProduct = (newPayload)=>{
        setPayloadCombo(newPayload);
    };
    const convertProductsAutogenCombo = ()=>{
        if (!dataAutogenCombo) return;
        const newProducts = dataAutogenCombo.map((prod)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            const sku = prod.productInfo.sku;
            const quantity = ((ref = payloadCombo.comboLineItems.find((line)=>line.sku === sku)) === null || ref === void 0 ? void 0 : ref.quantity) || 1;
            const convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .convertProductDetail */ .NP)(prod);
            const selectionPromotion = convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref1 = convertedProduct.selectionPromotions) === null || ref1 === void 0 ? void 0 : ref1[0];
            let gifts = [];
            const vouchers = [];
            (prod.defaultPromotions || []).forEach((el)=>{
                var ref, ref1, ref2, ref3;
                if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref1 = ref.gifts) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                    gifts = [
                        ...gifts,
                        ...el.benefit.gifts
                    ];
                }
                if (el === null || el === void 0 ? void 0 : (ref2 = el.benefit) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.voucher) === null || ref3 === void 0 ? void 0 : ref3.name) {
                    vouchers.push(el.benefit.voucher);
                }
            });
            if (selectionPromotion) {
                var ref8, ref9, ref10, ref11;
                if (!!(selectionPromotion === null || selectionPromotion === void 0 ? void 0 : (ref8 = selectionPromotion.benefit) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.gifts) === null || ref9 === void 0 ? void 0 : ref9.length)) {
                    gifts = [
                        ...gifts,
                        ...selectionPromotion.benefit.gifts
                    ];
                }
                if (selectionPromotion === null || selectionPromotion === void 0 ? void 0 : (ref10 = selectionPromotion.benefit) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.voucher) === null || ref11 === void 0 ? void 0 : ref11.name) {
                    vouchers.push(selectionPromotion.benefit.voucher);
                }
            }
            return {
                sku,
                quantity,
                image: prod.productInfo.imageUrl,
                name: prod.productInfo.name,
                selectedVariant: (convertedProduct.selected || []).map((v)=>v.value),
                supplierRetailPrice: Number(prod === null || prod === void 0 ? void 0 : (ref2 = prod.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.supplierRetailPrice) || 0,
                latestPrice: Number(prod === null || prod === void 0 ? void 0 : (ref4 = prod.prices) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.latestPrice) || 0,
                selectionPromotionId: selectionPromotion === null || selectionPromotion === void 0 ? void 0 : selectionPromotion.id,
                defaultPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.defaultPromotions) || [],
                selectionPromotion,
                selectionPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.selectionPromotions) || [],
                allowSelectPromotion: (convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref6 = convertedProduct.selectionPromotions) === null || ref6 === void 0 ? void 0 : ref6.length) && (convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref7 = convertedProduct.selectionPromotions) === null || ref7 === void 0 ? void 0 : ref7.length) > 0,
                totalAvailable: prod.totalAvailable,
                gifts,
                vouchers
            };
        });
        setProducts(newProducts);
        updatePrice(newProducts);
    };
    const convertProductsDynamicCombo = ()=>{
        if (!dataDynamicCombo) return;
        const newProducts = dataDynamicCombo.products.map((comboItem)=>{
            var ref, ref1, ref2, ref3, ref4, ref5;
            const sku = comboItem === null || comboItem === void 0 ? void 0 : comboItem.product.productInfo.sku;
            const sellerSku = comboItem === null || comboItem === void 0 ? void 0 : comboItem.product.productInfo.sellerSku;
            const quantity = comboItem === null || comboItem === void 0 ? void 0 : comboItem.quantity;
            const convertedProduct = (comboItem === null || comboItem === void 0 ? void 0 : comboItem.product) ? (0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .convertProductDetail */ .NP)(comboItem === null || comboItem === void 0 ? void 0 : comboItem.product) : null;
            let gifts = [];
            const vouchers = [];
            ((comboItem === null || comboItem === void 0 ? void 0 : comboItem.product.promotions) || []).forEach((el)=>{
                var ref, ref1, ref2, ref3;
                if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref1 = ref.gifts) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                    gifts = [
                        ...gifts,
                        ...el.benefit.gifts
                    ];
                }
                if (el === null || el === void 0 ? void 0 : (ref2 = el.benefit) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.voucher) === null || ref3 === void 0 ? void 0 : ref3.name) {
                    vouchers.push(el.benefit.voucher);
                }
            });
            return {
                sku,
                sellerSku,
                quantity,
                image: comboItem === null || comboItem === void 0 ? void 0 : comboItem.product.productInfo.imageUrl,
                name: comboItem === null || comboItem === void 0 ? void 0 : comboItem.product.productInfo.name,
                selectedVariant: ((convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.selected) || []).map((v)=>v.value),
                supplierRetailPrice: Number(comboItem === null || comboItem === void 0 ? void 0 : (ref = comboItem.product) === null || ref === void 0 ? void 0 : (ref1 = ref.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.supplierRetailPrice) || 0,
                latestPrice: Number(comboItem === null || comboItem === void 0 ? void 0 : (ref3 = comboItem.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.prices) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.latestPrice) || 0,
                defaultPromotions: (comboItem === null || comboItem === void 0 ? void 0 : comboItem.product.promotions) || [],
                selectionPromotion: null,
                selectionPromotions: [],
                allowSelectPromotion: false,
                totalAvailable: comboItem === null || comboItem === void 0 ? void 0 : comboItem.product.totalAvailable,
                gifts,
                vouchers
            };
        });
        setComboPromotion(_objectSpreadProps(_objectSpread({}, dataDynamicCombo.promotion), {
            id: dataDynamicCombo.id
        }));
        setProducts(newProducts);
        setSupplierRetailPrice(Number(dataDynamicCombo.supplierRetailPrice) || 0);
        setLatestPrice(Number(dataDynamicCombo.latestPrice) || 0);
    };
    const onFinish = (callback)=>{
        callback(type, payloadCombo);
    };
    const convertProducts = ()=>{
        if (type === "autogen") return convertProductsAutogenCombo();
        else return convertProductsDynamicCombo();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setPayloadCombo(payload);
    }, [
        JSON.stringify(payload)
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        convertProducts();
    }, [
        JSON.stringify(dataAutogenCombo),
        JSON.stringify(dataDynamicCombo)
    ]);
    return {
        payloadCombo,
        products,
        latestPrice,
        supplierRetailPrice,
        onChangeQuantity,
        comboPromotion,
        onChangeAutogenProduct,
        onChangeDynamicProduct,
        onFinish,
        loadingCombo: type === "autogen" ? !errorAutogen && !dataAutogenCombo : isLoadingDynamicCombo
    };
};
const useAutogenPrices = (sku, supplierRetailPrice, selectPromotionId)=>{
    const { terminal  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { cartServiceV2  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const { data: calculatePrice  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(!!sku && !!terminal ? [
        "cart_service/calculate_price",
        sku,
        terminal,
        selectPromotionId
    ] : null, async (_, sku, selectPromotionId)=>{
        return await cartServiceV2.calculatePrice({
            sku,
            selectPromotionId
        });
    }, {
        revalidateOnFocus: false
    });
    const { data: { saveWithoutSelectionPromotion , priceWithoutSelectionPromotion ,  } = {} ,  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(!!sku && !!terminal ? [
        "cart_service/calculate_save_without_selection_promotion",
        sku,
        terminal, 
    ] : null, async (_, sku)=>{
        const { price: priceWithoutSelectionPromotion  } = await cartServiceV2.calculatePrice({
            sku,
            selectPromotionId: undefined
        });
        if (!isNaN(+supplierRetailPrice) && !isNaN(+priceWithoutSelectionPromotion)) return {
            saveWithoutSelectionPromotion: +supplierRetailPrice - priceWithoutSelectionPromotion,
            priceWithoutSelectionPromotion
        };
        return {
            saveWithoutSelectionPromotion: undefined,
            priceWithoutSelectionPromotion: undefined
        };
    }, {
        revalidateOnFocus: false
    });
    return {
        latestPrice: calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.price,
        saveWithoutSelectionPromotion,
        priceWithoutSelectionPromotion
    };
};
const useAutogenSelectedProduct = (index, prod)=>{
    const { 0: skuVariant , 1: setSkuVariant  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(prod.sku);
    const { 0: selectionPromotionId , 1: setSelectionPromotionId  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(prod.selectionPromotionId);
    const { 0: quantity , 1: setQuantity  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(prod.quantity);
    const { 0: convertProduct , 1: setConvertProduct  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const { result: { product  } , isLoading ,  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_4__/* .useDiscoveryProduct */ .uD)(skuVariant);
    const { latestPrice , priceWithoutSelectionPromotion , saveWithoutSelectionPromotion ,  } = useAutogenPrices(prod === null || prod === void 0 ? void 0 : prod.sku, prod === null || prod === void 0 ? void 0 : prod.supplierRetailPrice, selectionPromotionId);
    const onChangeVariant = (variant, index)=>{
        const newSku = getNewVariant(product, variant, index);
        if (!!newSku) {
            setSkuVariant(newSku);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        var ref, ref1, ref2;
        if (!product || !latestPrice) return;
        const convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .convertProductDetail */ .NP)(product);
        const selectionPromotion = ((convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.selectionPromotions) || []).find((el)=>el.id === selectionPromotionId) || null;
        let gifts = [];
        const vouchers = [];
        (product.defaultPromotions || []).forEach((el)=>{
            var ref, ref1, ref2, ref3;
            if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref1 = ref.gifts) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                gifts = [
                    ...gifts,
                    ...el.benefit.gifts
                ];
            }
            if (el === null || el === void 0 ? void 0 : (ref2 = el.benefit) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.voucher) === null || ref3 === void 0 ? void 0 : ref3.name) {
                vouchers.push(el.benefit.voucher);
            }
        });
        const newProduct = {
            sku: skuVariant,
            sellerSku: product.productInfo.sellerSku,
            quantity,
            image: product.productInfo.imageUrl,
            name: product.productInfo.name,
            selectedVariant: (convertedProduct.selected || []).map((v)=>v.value),
            supplierRetailPrice: Number(product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.supplierRetailPrice) || 0,
            latestPrice,
            selectionPromotionId,
            defaultPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.defaultPromotions) || [],
            selectionPromotion,
            selectionPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.selectionPromotions) || [],
            allowSelectPromotion: true,
            totalAvailable: product.totalAvailable,
            gifts,
            vouchers,
            saveWithoutSelectionPromotion,
            productConfigurations: convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref2 = convertedProduct.productGroup) === null || ref2 === void 0 ? void 0 : ref2.configurations,
            priceWithoutSelectionPromotion,
            uomName: convertedProduct.uomName || ""
        };
        setConvertProduct(newProduct);
    }, [
        JSON.stringify(product),
        selectionPromotionId,
        quantity,
        latestPrice,
        saveWithoutSelectionPromotion,
        priceWithoutSelectionPromotion, 
    ]);
    const onFinish = (callback)=>{
        if (!convertProduct) return;
        callback(index, convertProduct);
    };
    return {
        product: convertProduct,
        onChangeVariant,
        onChangeQuantity: setQuantity,
        onChangeSelectionPromotionId: setSelectionPromotionId,
        onFinish,
        loading: isLoading,
        selectionPromotionId
    };
};
const useDynamicSelectedProduct = (param)=>{
    let { payload , selectedProductIdx  } = param;
    const { 0: payloadCombo , 1: setPayloadCombo  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(payload);
    const { result: { combo: dataDynamicCombo  } , isLoading: isLoadingDynamicCombo ,  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_4__/* .useRecommendationComboDetail */ .lR)(payloadCombo, true);
    const { 0: convertProduct , 1: setConvertProduct  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const onChangeVariant = (variant, variantIndex)=>{
        var ref;
        const product = (ref = dataDynamicCombo === null || dataDynamicCombo === void 0 ? void 0 : dataDynamicCombo.products[selectedProductIdx]) === null || ref === void 0 ? void 0 : ref.product;
        if (!product) return;
        const newSku = getNewVariant(product, variant, variantIndex);
        if (!!newSku) {
            const newPayloadCombo = _objectSpread({}, payloadCombo);
            newPayloadCombo.comboLineItems = payloadCombo.comboLineItems.map((lineItem, index)=>{
                if (selectedProductIdx === index) return {
                    sku: newSku,
                    sellerSku: lineItem.sellerSku,
                    quantity: lineItem.quantity
                };
                return lineItem;
            });
            setPayloadCombo(newPayloadCombo);
        }
    };
    const onFinish = (callback)=>{
        callback(payloadCombo);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        var ref, ref1, ref2, ref3, ref4;
        if (!dataDynamicCombo) return;
        const comboProduct = dataDynamicCombo.products[selectedProductIdx];
        if (!comboProduct) return;
        const product = comboProduct.product;
        const convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .convertProductDetail */ .NP)(product);
        let gifts = [];
        const vouchers = [];
        (product.defaultPromotions || []).forEach((el)=>{
            var ref, ref1, ref2, ref3;
            if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref1 = ref.gifts) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                gifts = [
                    ...gifts,
                    ...el.benefit.gifts
                ];
            }
            if (el === null || el === void 0 ? void 0 : (ref2 = el.benefit) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.voucher) === null || ref3 === void 0 ? void 0 : ref3.name) {
                vouchers.push(el.benefit.voucher);
            }
        });
        const supplierRetailPrice = Number(product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.supplierRetailPrice) || 0;
        const latestPrice = Number(product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.latestPrice) || 0;
        const newProduct = {
            sku: product.productInfo.sku,
            sellerSku: product.productInfo.sellerSku,
            quantity: comboProduct.quantity,
            image: product.productInfo.imageUrl,
            name: product.productInfo.name,
            selectedVariant: (convertedProduct.selected || []).map((v)=>v.value),
            supplierRetailPrice,
            latestPrice,
            defaultPromotions: (product === null || product === void 0 ? void 0 : product.promotions) || [],
            selectionPromotion: null,
            selectionPromotions: [],
            allowSelectPromotion: false,
            totalAvailable: product.totalAvailable,
            gifts,
            vouchers,
            saveWithoutSelectionPromotion: supplierRetailPrice - latestPrice,
            productConfigurations: (ref4 = convertedProduct.productGroup) === null || ref4 === void 0 ? void 0 : ref4.configurations,
            uomName: convertedProduct.uomName || ""
        };
        setConvertProduct(newProduct);
    }, [
        JSON.stringify(dataDynamicCombo),
        selectedProductIdx
    ]);
    return {
        product: convertProduct,
        onChangeVariant,
        onFinish,
        loading: isLoadingDynamicCombo
    };
};
const getNewVariant = (product, variant, index)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .convertProductDetail */ .NP)(product);
    if (!(convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref = convertedProduct.selected) === null || ref === void 0 ? void 0 : ref.length)) {
        return;
    }
    const selectedVariants = [];
    const optionId = typeof variant.optionId === "number" ? variant.optionId : (0,_teko_utils__WEBPACK_IMPORTED_MODULE_6__/* .stringToInteger */ .C)(variant.optionId, 0);
    const att = {
        code: ((ref1 = convertedProduct.productGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.configurations) === null || ref2 === void 0 ? void 0 : ref2[index].code) || "",
        value: variant.value,
        id: optionId,
        optionId
    };
    for(let i = 0; i < ((convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref3 = convertedProduct.productGroup) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.configurations) === null || ref4 === void 0 ? void 0 : ref4.length) || 0); i++){
        var ref7;
        if (((ref7 = convertedProduct.selected[i]) === null || ref7 === void 0 ? void 0 : ref7.code) === att.code) {
            selectedVariants.push(att);
        } else {
            selectedVariants.push(convertedProduct.selected[i]);
        }
    }
    if (!selectedVariants.length) {
        return;
    }
    let max = 0;
    let newSku = "";
    (ref5 = convertedProduct.productGroup) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.variants) === null || ref6 === void 0 ? void 0 : ref6.forEach((variant)=>{
        let countAtt = 0;
        for(let i = 0; i < variant.attributeValues.length; i++){
            var ref, ref1;
            if (((ref = variant.attributeValues[i]) === null || ref === void 0 ? void 0 : ref.optionId) === ((ref1 = selectedVariants[i]) === null || ref1 === void 0 ? void 0 : ref1.optionId)) {
                countAtt++;
            } else {
                break;
            }
        }
        if (countAtt > max) {
            max = countAtt;
            newSku = variant.sku;
        }
    });
    if (newSku && newSku !== convertedProduct.sku) return newSku;
};


/***/ })

}]);